var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLargeArrowLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12487_15143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3778 12.5779L19.2778 23.6779C19.244 23.7117 19.2315 23.7358 19.2276 23.7449C19.2266 23.7471 19.226 23.7488 19.2255 23.75C19.226 23.7513 19.2266 23.753 19.2276 23.7552C19.2315 23.7643 19.244 23.7884 19.2778 23.8222L19.2813 23.8257L19.2813 23.8257L30.3813 35.0257L28.8187 36.5744L17.7222 25.3779C17.7216 25.3772 17.7209 25.3766 17.7203 25.3759C17.2851 24.9399 17.025 24.3679 17.025 23.75C17.025 23.1312 17.2859 22.5585 17.7222 22.1222L28.8222 11.0222L30.3778 12.5779Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12487_15143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 25.6,
    fill: "white",
    transform: "translate(17 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLargeArrowLeftLight);
export default __webpack_public_path__ + "static/media/icon_large_arrow_left_light.9da7c97e.svg";
export { ForwardRef as ReactComponent };